<template>
  <div class="container-fluid">
    <esign-form
      :loading="loading"
      :esignData="esign"
      :formErrors="formErrors"
      @esignSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultEsign from "../defaultEsign";
import EsignForm from "../partials/EsignForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    EsignForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      esign: cloneDeep(defaultEsign),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(esign) {
      this.loading = true;

      const esignData = cloneDeep(esign);
      delete esignData.id;

      try {
        await this.$store.dispatch("esigns/add", esignData);
        this.$notify({
          type: "success",
          message: this.$t("ESIGNS.ESIGN_ADDED"),
        });
        const esign = await this.$store.getters["esigns/esign"];
        this.$emit("onViewEsign", esign, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
